const QUEUE_KEY = 'wc_offline_orders';
const STATUS_KEY = 'wc_offline_status_updates';

export function getQueuedOrders() {
  try { return JSON.parse(sessionStorage.getItem(QUEUE_KEY) || '[]'); } catch { return []; }
}

export function getQueuedStatusUpdates() {
  try { return JSON.parse(sessionStorage.getItem(STATUS_KEY) || '[]'); } catch { return []; }
}

export function queueOrder(orderData) {
  const orders = getQueuedOrders();
  orders.push({ ...orderData, offline_id: `offline_${Date.now()}_${Math.random().toString(36).slice(2)}`, created_at: new Date().toISOString() });
  sessionStorage.setItem(QUEUE_KEY, JSON.stringify(orders));
  return orders.length;
}

export function queueStatusUpdate(orderId, status) {
  const updates = getQueuedStatusUpdates();
  updates.push({ order_id: orderId, status, timestamp: new Date().toISOString() });
  sessionStorage.setItem(STATUS_KEY, JSON.stringify(updates));
  return updates.length;
}

export function clearQueue() {
  sessionStorage.removeItem(QUEUE_KEY);
  sessionStorage.removeItem(STATUS_KEY);
}

export function getTotalQueued() {
  return getQueuedOrders().length + getQueuedStatusUpdates().length;
}

export async function syncQueue(api) {
  const orders = getQueuedOrders();
  const statusUpdates = getQueuedStatusUpdates();

  if (orders.length === 0 && statusUpdates.length === 0) return { synced: 0 };

  try {
    const { data } = await api.post('/sync/orders', {
      new_orders: orders,
      status_updates: statusUpdates
    });
    // Clear on success
    clearQueue();
    return { synced: (data.orders_created || 0) + (data.status_updates || 0), errors: data.errors || [] };
  } catch (e) {
    return { synced: 0, error: e.message };
  }
}

